import { ISelfResponse, IUpdateSelfRequest } from '@/shared/interfaces';
import { fetchIStatus } from '@/shared/fetchIStatus';

export const updateSelf = async (
    newValue: IUpdateSelfRequest,
): Promise<ISelfResponse> => {
    return await fetchIStatus('/api/patients/self/v2', 'post', newValue);
};
